module.exports = __webpack_public_path__ + "static/img/neirong_2.ff0e277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/neirong_2.png
// module id = qWjB
// module chunks = 1